<template>
  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="sidebar rightfloat">
    <div class="grid-content bg-purple">

      <LoginControl class="Pclogin"></LoginControl>
      <div class="qkcontent qkjjtext">
        <el-container>
          <el-aside width="50%">
            <!-- <img src="../../assets/images/coverpic.jpg" alt width="100%" /> -->
            <img :src="ImgUrl+imgUrl" alt width="100%"/>
          </el-aside>
          <el-container>
            <div class="qktext">
              
              <p>{{YearIssue_NoTtitle}}</p>
              <p title="出版日期">{{newYears.split("T")[0]}}</p>
              <el-row style="margin-top:20px">
                <el-button @click="$router.push('/OAList?IssueId=-1')">
                  <span  style="color:red;">
                  <!-- <router-link to="/FixedBody?ItemId=10" style="color:red;">详细信息</router-link> -->
                  当期目录
                  </span>
                </el-button>
              </el-row>
              <div class="textfooter">
                <p>
                  <span class="strong">CN</span>
                  {{CN}}
                </p>
                <p>
                  <span class="strong">ISSN</span>
                  {{ISSN}}
                </p>
              </div>
            </div>
          </el-container>
        </el-container>
      </div>
      <!--期刊社动态/作者营地-->
      <div class="tgxz fifth">
        <span class="title_more">
          <a @click="onick"></a>
        </span>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="期刊动态" name="first" class="buttona">
            <Control :params="{ColumnId:2,PageSize:5}"></Control>
          </el-tab-pane>
          <el-tab-pane label="作者园地" class="buttona" name="two">
            <Control :params="{ColumnId:1,PageSize:5}"></Control>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--排名-->
      <div class="tgxz ten">
        <span class="title_more">
          <a @click="onicka"></a>
        </span>
        <el-tabs v-model="activeNamea" type="card" @tab-click="handleClicka">
          <el-tab-pane label="下载排行" name="firsta" class="buttona">
          <Ranking :params="{PageIndex:0,PageSize:5,Type:'Sort',Key:'ReadRank'}"></Ranking>
          </el-tab-pane>
          <el-tab-pane label="浏览排行" class="buttona" name="twoa">
            <Ranking :params="{PageIndex:0,PageSize:5,Type:'Sort',Key:'ViewRank'}"></Ranking>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--友情链接-->
      <div class="tgxz ten">
         <span class="title_more">
          <router-link to="/Links"></router-link>
        </span>
        <el-tabs v-model="activeNameb" type="card" @tab-click="handleClick">
          <el-tab-pane label="友情链接" name="firstb" class="buttona">
            <FrLinks></FrLinks>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-col>
</template>

<script>
import Control from "./page/Control";
import Ranking from "./page/Ranking";
import FrLinks from "./page/FrLinks";
import LoginControl from "../LoginControl";
export default {
  name: "Sidebar",
  data() {
    return {
      activeName: "first",
      type: 1,
      activeNamea: "firsta",
      activeNameb: "firstb",
      slqk: "",
      data: {},
      Volume: "",
      newYears: "",
      newMonth: "",
      SetItem: {},
      ISSN: "",
      CN: "",
      imgUrl:"",
      YearIssue_NoTtitle:""
    };
  },
  components: { Control, FrLinks, LoginControl,Ranking },
  mounted() {
    if (this.$route.path == "/FixedBody") {
      this.activeName = "first";
    } else if (this.$route.path === "/Authorgarden") {
      this.activeName = "two";
    }
    if (sessionStorage.getItem("slqk")) {
      this.slqk = JSON.parse(sessionStorage.getItem("slqk"));
    } else {
      let params = [80, 8, 9, 1400];
      this.$store.dispatch("_getHeader", params).then(res => {
        res.data.Data.map(item=>{
          if(item.ItemId==1400){
            this.slqk = item.Body;
        sessionStorage.setItem("slqk", JSON.stringify(item.Body));
        }
        })
        
        
      });
    }
    if (sessionStorage.getItem("newYears")) {
      this.data = JSON.parse(sessionStorage.getItem("newYears"));
      this.Volume = this.data.Volume;
      this.newYears = this.data.newYears

      this.imgUrl=this.data.CoverGUID+this.data.CoverSuffix
      this.YearIssue_NoTtitle=this.data.YearIssue_NoTtitle
    } else {
      this.$store.dispatch("_getYear", { Id: -1 }).then(res => {
        if(res.data.Data){
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
        let data = {
         newYears:res.data.Data.Publish_Date,
            Volume:res.data.Data.Volume,
            CoverGUID:res.data.Data.CoverGUID,
            CoverSuffix:res.data.Data.CoverSuffix,
            YearIssue_NoTtitle:res.data.Data.YearIssue_NoTtitle
        };
        this.Volume = res.data.Data.Volume;
         this.newYears = res.data.Data.Publish_Date
        this.imgUrl=res.data.Data.CoverGUID+res.data.Data.CoverSuffix
        this.YearIssue_NoTtitle=res.data.Data.YearIssue_NoTtitle
        sessionStorage.setItem("newYears", JSON.stringify(data));
        }
        
        
      });
    }
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map(item => {
        if (item.SetItemID == 5000) {
          this.ISSN = item.Item_Value;
        }
        if (item.SetItemID == 5010) {
          this.CN = item.Item_Value;
        }
      });
    } else {
      let params = [
        1000,
        1001,
        4530,
        6018,
        6019,
        230,
        6055,
        5000,
        5010,
        99,
        96,
        11,
        2960,
        4553
      ];
      this.$store.dispatch("_getSet", params).then(res => {
        this.SetItem = res.data.Data;
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        this.SetItem.map(item => {
          if (item.SetItemID == 5000) {
            this.ISSN = item.Item_Value;
          }
          if (item.SetItemID == 5010) {
            this.CN = item.Item_Value;
          }
        });
      });
    }
  },
  methods: {
    handleClick(tab, event) {},
    handleClicka(tab, event) {},
    onick() {
      if (this.activeName == "first") {
        this.$router.push({
          path: "/NewsList"
        });
      } else if (this.activeName == "two") {
        this.$router.push({
          path: "/Authorgarden"
        });
      }
    },
    onicka(){
       if (this.activeNamea == "firsta") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ReadRank"
        });
      } else if (this.activeNamea == "twoa") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ViewRank"
        });
      }
    },
    
  }
};
</script>

<style>
.qktext p{
  line-height: 24px;
}
.qkjjtext img{
  height: 210px;
  display: inline-block;
}
</style>
